import { login,smsLogin, getInfo, logout, getAccessPlatformInfo, trustAuthLogin, getEntBusinessInfo} from '@/api/login'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getVerifyInfo } from '@/api/infoCollection/entSelfRegister'
import {getAppAttributeList, getWxAppInfo} from '@/api/open/app'

const user = {
  state: {
    token: getToken(),
    user: {},
    roles: [],
    permission: {},
    // 第一次加载菜单时用到
    loadMenus: false,
    // 平台信息
    platformInfo: null,
    // 是否会员
    isMember: false,
		// 企业业务信息
		entBusinessInfo: [],
    // 企业认证信息
    verifyInfo: {},
    // 会员信息
    memberInfo: {},
    // 会员权益
    interest: {},

    // 应用权限
    appCode: [],

    // 小程序应用信息
    wxAppInfo: null,
    //AI应用信息
    aiAppInfo: null,
    // 登录密码是否已过期（true 时全局强制弹出修改密码窗口）
    pwdExpired: false,
    // 密码是否过期是否校验中（校验期间同样让修改密码弹窗优先，避免协议弹窗抢先弹出）
    pwdExpiredPending: false
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles
    },
    SET_LOAD_MENUS: (state, loadMenus) => {
      state.loadMenus = loadMenus
    },
    //平台信息
    SET_PLATFORM_INFO: (state, platformInfo) => {
      state.platformInfo = platformInfo
      if (platformInfo) {
        setTitleIcon(platformInfo.titleUrl)
      }
    },
		//企业业务信息
		SET_ENT_BUSINESS_INFO: (state, entBusinessInfo) => {
		  state.entBusinessInfo = entBusinessInfo
		},
    // 企业认证信息
    SET_VERIFY_INFO: (state, verifyInfo) => {
      state.verifyInfo = verifyInfo
    },
    SET_MEMBER_INFO: (state, memberInfo) => {
      state.memberInfo = memberInfo
    },
    SET_IS_MEMBER: (state, isMember) => {
      state.isMember = isMember
    },
    SET_INTEREST: (state, interest) => {
      state.interest = interest
    },
    SET_APP_CODE: (state, appCode) => {
      state.appCode = appCode
    },
    SET_PERMISSION: (state, permission) => {
      state.permission = permission
    },
    SET_WX_APP_INFO: (state, wxAppInfo) => {
      state.wxAppInfo = wxAppInfo
    },
    SET_PWD_EXPIRED: (state, pwdExpired) => {
      state.pwdExpired = pwdExpired
    },
    SET_PWD_EXPIRED_PENDING: (state, pending) => {
      state.pwdExpiredPending = pending
    }
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        if(userInfo.loginType === 'smsLogin'){
          smsLogin(userInfo).then(res => {
            if (res.trustAccess) {
              handleLoginSuccess(commit, res)
            }
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        }else{
          login(userInfo.username, userInfo.password, userInfo.code, userInfo.uuid, userInfo.captchaVerifyParam).then(res => {
            if (res.trustAccess) {
              handleLoginSuccess(commit, res)
            }
            resolve(res)
          }).catch(error => {
            reject(error)
          })
        }
      })
    },
    RegisterLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        handleLoginSuccess(commit, userInfo)
        resolve(userInfo)
      })
    },
    //授信登录
    TrustAuthLogin({ commit }, userInfo) {
      return new Promise((resolve, reject) => {
        trustAuthLogin({
          token: userInfo.token,
          verCode: userInfo.verCode
        }).then(res => {
          res.user.roles = res.roles
          res.user.userType = res.userType
          setToken(res.token)
          commit('SET_TOKEN', res.token)
          commit('SET_APP_CODE', res.appCode)

          setUserInfo(res.user, commit)
          // 第一次加载菜单时用到， 具体见 src 目录下的 permission.js
          commit('SET_LOAD_MENUS', true)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取用户信息
    GetInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getInfo().then(res => {
          res.user.roles = res.roles
          res.user.enterpriseList = res.enterpriseList
          commit('SET_APP_CODE', res.appCode)

          setUserInfo(res.user, commit)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({ commit }) {
      return new Promise((resolve, reject) => {
        logout().then(res => {
          logOut(commit)
          resolve()
        }).catch(error => {
          logOut(commit)
          reject(error)
        })
      })
    },

    // 获取平台信息
    GetAccessPlatformInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getAccessPlatformInfo().then(res => {
          commit('SET_PLATFORM_INFO', res)
          commit('SET_IS_MEMBER', res.model == 'MEMBER')
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

		// 获取企业业务信息
		GetEntBusinessInfo({ commit }) {
		  return new Promise((resolve, reject) => {
		    getEntBusinessInfo().then(res => {
		      commit('SET_ENT_BUSINESS_INFO', res)
		      resolve(res)
		    }).catch(error => {
		      reject(error)
		    })
		  })
		},

    // 获取企业认证信息
    GetVerifyInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getVerifyInfo().then(res => {
          commit('SET_VERIFY_INFO', res)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取微信小程序信息
    GetWxAppInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getWxAppInfo('YY00003').then(res => {
          commit('SET_WX_APP_INFO', res)
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 获取已开通应用的信息
    GetOpenAppInfo({ commit }, payload) {
      return new Promise((resolve, reject) => {
        if (!payload) {
          resolve(null)
          return
        }
        getAppAttributeList(payload).then(res => {
          resolve(res)
        }).catch(error => {
          reject(error)
        })
      })
    },

    updateLoadMenus({ commit }) {
      return new Promise((resolve, reject) => {
        commit('SET_LOAD_MENUS', false)
      })
    },
  }
}

export const handleLoginSuccess = (commit, res) => {
  // 关联企业列表为空
  if (!res.enterpriseList || res.enterpriseList.length <= 1) {
    res.user.roles = res.roles
    res.user.userType = res.userType
    setUserInfo(res.user, commit)

    setToken(res.token)
    commit('SET_TOKEN', res.token)
    commit('SET_APP_CODE', res.appCode)

  }
  res.user.enterpriseList = res.enterpriseList
  commit('SET_LOAD_MENUS', true)
}
// 设置该机构的小图标
export const setTitleIcon = (titleUrl) => {
  if (titleUrl) {
    let favicon = document.querySelector('link[rel="icon"]')
    favicon.href = titleUrl
  }
}

export const logOut = (commit) => {
  commit('SET_TOKEN', '')
  commit('SET_ROLES', [])
  commit('SET_APP_CODE', [])
  commit('SET_PWD_EXPIRED', false)
  commit('SET_PWD_EXPIRED_PENDING', false)
  removeToken()
  window.sessionStorage.clear()
}

export const setUserInfo = (res, commit) => {
  // 如果没有任何权限，则赋予一个默认的权限，避免请求死循环
  if (res.roles.length === 0) {
    commit('SET_ROLES', ['ROLE_SYSTEM_DEFAULT'])
  } else {
    commit('SET_ROLES', res.roles)
  }
  commit('SET_USER', res)
  const permission = {}
  res.roles.forEach(role => {
    permission[role] = true
  })
  commit('SET_PERMISSION', permission)
}


export default user
